//==============================================================================
// 画像入力フィールド
//==============================================================================
$(function() {
    $(document).on('change', '.image-container input[type="file"]', async function(event) {
        const $container = $(this).closest('.image-container');
        const name = $container.attr('data-name');
        const isCompress = $container.attr('data-compress');

        const file = event.target.files[0];
        if (!file) return;

        let compressedFile = file;

        if (isCompress) {
            const $imageCompressionProcessModal = $('#imageCompressionProcessModal');
            let $progressBar = null;

            let modalShownPromise = Promise.resolve();
            if ($imageCompressionProcessModal.length) {
                modalShownPromise = new Promise((resolve) => {
                    $imageCompressionProcessModal.one('shown.bs.modal', resolve);
                });
                $imageCompressionProcessModal.modal('show');
                $progressBar = $imageCompressionProcessModal.find('.progress-bar');
            }

            if ($progressBar) {
                $progressBar.css('width', '0%').attr('aria-valuenow', 0);
            }

            try {
                compressedFile = await imageCompression(file, {
                    maxSizeMB: 2,
                    maxWidthOrHeight: 1024,
                    useWebWorker: true,
                    onProgress: (progress) => {
                        if ($progressBar) {
                            $progressBar.css('width', progress + '%');
                            $progressBar.attr('aria-valuenow', progress);
                        }
                    },
                });

                const compressedFileObj = new File([compressedFile], file.name, {
                    type: compressedFile.type,
                    lastModified: Date.now(),
                });
                const dataTransfer = new DataTransfer();
                dataTransfer.items.add(compressedFileObj);
                $(this)[0].files = dataTransfer.files;
            } catch (error) {
                const $imageCompressionErrorModal = $('#imageCompressionErrorModal');
                if ($imageCompressionErrorModal.length) {
                    $imageCompressionErrorModal.modal('show');
                }
            } finally {
                if ($imageCompressionProcessModal.length) {
                    await modalShownPromise;
                    $imageCompressionProcessModal.modal('hide');
                }
            }
        }

        const reader = new FileReader();
        reader.onload = function(e) {
            const base64Data = e.target.result;

            // Base64 data
            $container.find('[data-image-component="base64"]').val(base64Data);
            $container.find('[data-image-component="filename"]').val(file.name);
            $container.find('[data-image-component="updated"]').val('1');
            $container.find('[data-image-component="deleted"]').val(null);
            $container.find('[data-image-component="preview"]').attr('src', base64Data);
            $container.find('[data-image-component="editable"]').show();
            $container.find('[data-image-component="input"]').hide();
        };
        reader.readAsDataURL(compressedFile);
    });
    $(document).on('click', '.image-container [data-image-component="change"]', function(event) {
        const $container = $(this).closest('.image-container');
        $container.find('input[type="file"]').trigger('click');
    });
    $(document).on('click', '.image-container [data-image-component="destroy"]', function(event) {
        const $container = $(this).closest('.image-container');
        const name = $container.attr('data-name');
        const id = $container.find('[data-image-component="id"]').val();
        if (id) {
            // 削除フラグを立てる
            $container.find('[data-image-component="updated"]').val(null);
            $container.find('[data-image-component="deleted"]').val('1');
        }
        $container.find('[data-image-component="base64"]').val(null);
        $container.find('[data-image-component="filename"]').val(null);
        $container.find('[data-image-component="updated"]').val(null);
        $container.find('[data-image-component="preview"]').attr('src', null);
        $container.find('input[type="file"]').val('');
        $container.find('[data-image-component="editable"]').hide();
        $container.find('[data-image-component="input"]').show();
    });
});
